import {
  ApprovalGroupRootPageDocument,
  DeleteRulesConfigurationDocument,
  SortRulesConfigurationsDocument,
  UpdatePositionsApprovalsRulesConfigurationPositionsInput,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useSortRulesConfigurations = () => {
  const [sortRules, { loading }] = useMutation(SortRulesConfigurationsDocument, {
    extractorFn: (data) => data.approvalsMutations.updatePositionsApprovalsRulesConfiguration,
  })

  return {
    loading,
    sortRulesConfigurations(positions: UpdatePositionsApprovalsRulesConfigurationPositionsInput[]) {
      return sortRules({
        variables: {
          positions,
        },
        refetchQueries: [ApprovalGroupRootPageDocument],
      })
    },
  }
}

export const useDeleteRulesConfiguration = () => {
  const [deleteRule, { loading }] = useMutation(DeleteRulesConfigurationDocument, {
    extractorFn: (data) => data.approvalsMutations.deleteApprovalsRulesConfiguration,
  })

  return {
    loading,
    deleteRuleConfiguration(id: number) {
      return deleteRule({
        variables: {
          id,
        },
        refetchQueries: [ApprovalGroupRootPageDocument],
      })
    },
  }
}
